import { render, staticRenderFns } from "./HodOnboardingAcceptedPage.vue?vue&type=template&id=5fb97dbc&scoped=true&"
import script from "./HodOnboardingAcceptedPage.vue?vue&type=script&lang=ts&"
export * from "./HodOnboardingAcceptedPage.vue?vue&type=script&lang=ts&"
import style0 from "./HodOnboardingAcceptedPage.vue?vue&type=style&index=0&id=5fb97dbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb97dbc",
  null
  
)

export default component.exports